
import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
} from "react-bootstrap";
import axios from "axios";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/* ---------- Lock Icon ---------- */
const IconLock = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const UserProfileEdit = () => {
  const [changePasswordS, setChangePasswordS] = useState({
    currentPassword: "",
    newPassword: "",
    verifyPassword: "",
  });

  const [loading, setLoading] = useState(false);

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;

    setChangePasswordS((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleReset = () => {
    setChangePasswordS({
      currentPassword: "",
      newPassword: "",
      verifyPassword: "",
    });
  };

  /* ---------- Change Password API ---------- */
  const ChangePasswoord = async (e) => {
    e.preventDefault();

    const {
      currentPassword,
      newPassword,
      verifyPassword,
    } = changePasswordS;

    if (
      !currentPassword ||
      !newPassword ||
      !verifyPassword
    ) {
      toast.warn("All fields are required.");
      return;
    }

    if (newPassword !== verifyPassword) {
      toast.error(
        "New password and verify password do not match."
      );
      return;
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const response = await axios.get(
        webServiceUrl.getProfile,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const email = response?.data?.data?.email;

      if (!email) {
        toast.error("Unable to retrieve user email.");
        return;
      }

      const passwordResponse = await axios.post(
        webServiceUrl.forgotPassword,
        {
          email,
          oldPassword: currentPassword,
          newPassword,
          confirmPassword: newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (passwordResponse.data.success) {
        toast.success(
          passwordResponse.data.message ||
            "Password changed successfully!"
        );

        handleReset();
      } else {
        toast.error(
          passwordResponse.data.message ||
            "Failed to change password."
        );
      }
    } catch (error) {
      console.error("Change Password Error:", error);

      toast.error(
        error.response?.data?.message ||
          "Something went wrong while changing password."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="content-inner"
        id="personal_information"
      >
        <Container>
          <Row>
            <Col lg={12}>
              <Card
                className="shadow-sm border-0"
                style={{ borderRadius: "14px" }}
              >
                <Card.Header className="bg-white border-0 pt-4 px-4 pb-0">
                  <h5 className="mb-1 fw-bold d-flex align-items-center gap-2">
                    <IconLock className="text-primary" />
                    Change Password
                  </h5>

                  <p
                    className="text-muted mb-0"
                    style={{ fontSize: "13.5px" }}
                  >
                    Choose a strong password you don't use
                    elsewhere.
                  </p>

                  <hr className="mt-3 mb-0" />
                </Card.Header>

                <Card.Body className="px-4 pb-4">
                  <Form onSubmit={ChangePasswoord}>
                    <Row className="gy-3">
                      <Col sm={6}>
                        <Form.Group className="form-group mb-0">
                          <Form.Label
                            htmlFor="cpass"
                            className="form-label fw-semibold"
                          >
                            Current Password
                          </Form.Label>

                          <Form.Control
                            type="password"
                            className="form-control py-2 rounded-3"
                            id="cpass"
                            name="currentPassword"
                            value={
                              changePasswordS.currentPassword
                            }
                            onChange={handlePasswordChange}
                            autoComplete="current-password"
                          />
                        </Form.Group>
                      </Col>

                      <Col sm={6}>
                        <Form.Group className="form-group mb-0">
                          <Form.Label
                            htmlFor="npass"
                            className="form-label fw-semibold"
                          >
                            New Password
                          </Form.Label>

                          <Form.Control
                            type="password"
                            className="form-control py-2 rounded-3"
                            id="npass"
                            name="newPassword"
                            value={changePasswordS.newPassword}
                            onChange={handlePasswordChange}
                            autoComplete="new-password"
                          />
                        </Form.Group>
                      </Col>

                      <Col sm={6}>
                        <Form.Group className="form-group mb-0">
                          <Form.Label
                            htmlFor="vpass"
                            className="form-label fw-semibold"
                          >
                            Verify Password
                          </Form.Label>

                          <Form.Control
                            type="password"
                            className="form-control py-2 rounded-3"
                            id="vpass"
                            name="verifyPassword"
                            value={
                              changePasswordS.verifyPassword
                            }
                            onChange={handlePasswordChange}
                            autoComplete="new-password"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <div className="mt-4 pt-3 border-top d-flex gap-2">
                      <Button
                        type="submit"
                        className="btn btn-app-accent px-4 rounded-3"
                        disabled={loading}
                      >
                        {loading
                          ? "Submitting..."
                          : "Submit"}
                      </Button>

                      <Button
                        type="button"
                        variant="outline-secondary"
                        className="px-4 rounded-3"
                        onClick={handleReset}
                        disabled={loading}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          style={{ fontSize: "15px" }}
        />
      </div>

      <style>{`
        #personal_information .text-primary {
          color: #16a34a !important;
        }

        #personal_information .btn-app-accent {
          background-color: #16a34a;
          border-color: #16a34a;
          color: #fff;
        }

        #personal_information .btn-app-accent:hover,
        #personal_information .btn-app-accent:focus,
        #personal_information .btn-app-accent:active {
          background-color: #15803d !important;
          border-color: #15803d !important;
          color: #fff !important;
        }
      `}</style>
    </>
  );
};

export default UserProfileEdit;













    //  <Tab.Pane eventKey="first" className="fade show">
    //                 <Card
    //                   className="shadow-sm border-0"
    //                   style={{ borderRadius: "14px" }}
    //                 >
    //                   <Card.Header className="bg-white border-0 pt-4 px-4 pb-0">
    //                     <h5 className="mb-1 fw-bold d-flex align-items-center gap-2">
    //                       <IconUser className="text-primary" />
    //                       Personal Information
    //                     </h5>
    //                     <p
    //                       className="text-muted mb-0"
    //                       style={{ fontSize: "13.5px" }}
    //                     >
    //                       Keep your basic details up to date.
    //                     </p>
    //                     <hr className="mt-3 mb-0" />
    //                   </Card.Header>
    //                   <Card.Body className="px-4 pb-4">
    //                     {loading ? (
    //                       <Loading />
    //                     ) : (
    //                       <Form onSubmit={handleProfileSubmit}>
    //                         <Row className="gy-3 my-1">
    //                           {/* Full Name */}
    //                           <Col sm={6}>
    //                             <Form.Label className="fw-semibold ">
    //                               Full Name
    //                             </Form.Label>
    //                             <Form.Control
    //                               type="text"
    //                               name="fullName"
    //                               value={editProfile.fullName}
    //                               onChange={handleEditChange}
    //                               className="py-2 rounded-3"
    //                             />
    //                           </Col>

    //                           {/* Gender */}
    //                           <Col sm={6}>
    //                             <Form.Label className="fw-semibold ">
    //                               Gender
    //                             </Form.Label>
    //                             <Form.Select
    //                               name="gender"
    //                               value={editProfile.gender}
    //                               onChange={handleEditChange}
    //                               className="py-2 rounded-3"
    //                             >
    //                               <option value="">Select</option>
    //                               <option value="M">Male</option>
    //                               <option value="F">Female</option>
    //                               <option value="other">Other</option>
    //                             </Form.Select>
    //                           </Col>

    //                           {/* Institute */}
    //                           <Col sm={6}>
    //                             <Form.Label className="fw-semibold ">
    //                               Institute Name
    //                             </Form.Label>
    //                             <Form.Control
    //                               type="text"
    //                               name="previous_school"
    //                               value={editProfile.previous_school}
    //                               onChange={handleEditChange}
    //                               className="py-2 rounded-3"
    //                             />
    //                           </Col>

    //                           {/* Email */}
    //                           <Col sm={6}>
    //                             <Form.Label className="fw-semibold ">
    //                               User Name{" "}
    //                             </Form.Label>
    //                             <Form.Control
    //                               type="text"
    //                               name="userName"
    //                               value={editProfile.userName}
    //                               // onChange={handleEditChange}
    //                               disabled
    //                               className="py-2 rounded-3 bg-light"
    //                             />
    //                           </Col>

    //                           {/* Contact */}
    //                           <Col sm={6}>
    //                             <Form.Label className="fw-semibold ">
    //                               Contact Number
    //                             </Form.Label>
    //                             <Form.Control
    //                               type="text"
    //                               name="contactNumber"
    //                               maxLength={10}
    //                               disabled
    //                               value={editProfile.contactNumber}
    //                               onChange={handleEditChange}
    //                               className="py-2 rounded-3"
    //                             />
    //                           </Col>
    //                           <Col sm={6}>
    //                             <Form.Label className="fw-semibold ">
    //                               Email
    //                             </Form.Label>
    //                             <Form.Control
    //                               type="email"
    //                               name="email"
    //                               value={editProfile.email}
    //                               onChange={handleEditChange}
    //                               className="py-2 rounded-3"
    //                             />
    //                           </Col>

    //                           {/* Profile Image Preview */}
    //                           {data?.profileImg && (
    //                             <Col sm={6}>
    //                               <Form.Label className="fw-semibold ">
    //                                 Cast Certificate
    //                               </Form.Label>
    //                               <div className="mt-2 p-2 border rounded-3 d-inline-block bg-light">
    //                                 <img
    //                                   src={data.profileImg}
    //                                   alt="profile"
    //                                   className="img-fluid rounded-2 border"
    //                                   style={{ maxWidth: "150px" }}
    //                                 />
    //                               </div>
    //                             </Col>
    //                           )}
    //                         </Row>

    //                         {/* Buttons */}
    //                         <div className="mt-4 pt-3 border-top d-flex gap-2">
    //                           <Button
    //                             type="submit"
    //                             className="btn btn-app-accent px-4 rounded-3"
    //                           >
    //                             Update Profile
    //                           </Button>

    //                           <Button
    //                             type="reset"
    //                             className="btn  px-4 rounded-3"
    //                             onClick={() => setEditProfile(data)}
    //                           >
    //                             Cancel
    //                           </Button>
    //                         </div>
    //                       </Form>
    //                     )}
    //                   </Card.Body>
    //                 </Card>
    //               </Tab.Pane>